import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div  style={{textAlign:'left', overflowWrap: 'break-word' }}>
				<p>The code you entered is for a pediatric formula for inborn metabolic diseases and the patient is an adult, or the patient is a child who does not have an inborn metabolic disease.</p>
				<p>For information on coding, refer to the Enteral Product Classification List available at www.emedny.org, click on ‘Provider Manuals’, then ‘DME’, then ‘Provider Communications’.</p>
			
				<div className="button" onClick={()=>this.props.navigate('D8')}>Enter Another Code</div>
			</div>
		);
	}
}